import { render, staticRenderFns } from "./HugeCalScoreSection.vue?vue&type=template&id=06edebb6&scoped=true&"
import script from "./HugeCalScoreSection.vue?vue&type=script&lang=js&"
export * from "./HugeCalScoreSection.vue?vue&type=script&lang=js&"
import style0 from "./HugeCalScoreSection.vue?vue&type=style&index=0&id=06edebb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06edebb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06edebb6')) {
      api.createRecord('06edebb6', component.options)
    } else {
      api.reload('06edebb6', component.options)
    }
    module.hot.accept("./HugeCalScoreSection.vue?vue&type=template&id=06edebb6&scoped=true&", function () {
      api.rerender('06edebb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HugeCalScoreSection.vue"
export default component.exports